import { ResponsiveSheet } from "./ResponsiveSheet";
import type { DailyTimelineLabels } from "./types";

interface NoShowConfirmSheetProps {
  open: boolean;
  labels: DailyTimelineLabels;
  onClose: () => void;
  onConfirm: () => void;
}

export function NoShowConfirmSheet({ open, labels, onClose, onConfirm }: NoShowConfirmSheetProps) {
  return (
    <ResponsiveSheet
      open={open}
      onClose={onClose}
      title={labels.noShowConfirmTitle}
      closeLabel={labels.closeSheet}
      footer={
        <div className="flex gap-2 justify-end">
          <button
            type="button"
            onClick={onClose}
            className="h-12 px-4 rounded-biz-btn text-sm font-semibold border border-biz-border text-biz-foreground hover:bg-biz-muted biz-focus-ring biz-motion-safe transition-colors"
          >
            {labels.noShowConfirmNo}
          </button>
          <button
            type="button"
            onClick={onConfirm}
            className="h-12 px-4 rounded-biz-btn text-sm font-semibold bg-biz-warning text-biz-warning-foreground hover:opacity-90 biz-focus-ring biz-motion-safe transition-opacity"
          >
            {labels.noShowConfirmYes}
          </button>
        </div>
      }
    >
      <p className="text-sm text-biz-foreground-muted">{labels.noShowConfirmBody}</p>
    </ResponsiveSheet>
  );
}
